var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", "max-width": _vm.width },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        { attrs: { "data-testid": _vm.testId } },
        [
          _c(
            "v-toolbar",
            { attrs: { dark: "", color: "primary" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticStyle: {
                    "font-size": "17px",
                    "margin-left": "10px !important"
                  }
                },
                [_vm._v("\n        " + _vm._s(_vm.titulo) + "\n      ")]
              )
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "div",
            { attrs: { id: "alinear" } },
            [
              !_vm.items
                ? _c("v-card-text", [
                    _vm._v("\n        " + _vm._s(_vm.mensaje) + "\n      ")
                  ])
                : _vm._e(),
              _c("div", [_vm._t("default")], 2),
              _vm.items
                ? _c(
                    "div",
                    [
                      _c("v-card-text", [
                        _vm._v(
                          "\n          " + _vm._s(_vm.mensaje) + "\n        "
                        )
                      ]),
                      _vm.items
                        ? _c("v-card-text", [
                            _c(
                              "ul",
                              _vm._l(_vm.items, function(item) {
                                return _c("li", { key: item }, [
                                  _vm._v(_vm._s(item))
                                ])
                              }),
                              0
                            ),
                            _c("br"),
                            _c("br")
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c("v-divider"),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm.mostrarBoton
                ? _c(
                    "v-btn",
                    {
                      attrs: {
                        "data-testid": "v-btn--cancelar",
                        color: "white",
                        depressed: "",
                        small: ""
                      },
                      on: {
                        click: function($event) {
                          return _vm.closeModal(false)
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "#526da5" } }, [
                        _vm._v(_vm._s(_vm.textoBtnNo))
                      ])
                    ]
                  )
                : _vm._e(),
              _c(
                "v-btn",
                {
                  attrs: {
                    "data-testid": "v-btn--aceptar",
                    color: "#526da5",
                    depressed: "",
                    small: ""
                  },
                  on: {
                    click: function($event) {
                      return _vm.closeModal(true)
                    }
                  }
                },
                [
                  _c("span", { staticStyle: { color: "white" } }, [
                    _vm._v(_vm._s(_vm.textoBtnSi))
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }